/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: Dashboard
 * (C) Copyright IBM Corp. 2019, 2021
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'../../../lib/@waca/dashboard-common/dist/core/APIFactory',
	'./QueryDefinition',
	'./api/QueryService2API'
], (APIFactory, QueryDefinition, QueryServiceAPI2) => {
	class QueryService2 {

		constructor(options) {
			const internalQueryService = options.features['QueryService.internal'];
			this.dashboard = options.features['API'];
			this.internalQueryService = internalQueryService;
			this.queryClasses = {};
			this.queryDefinitions = [];
		}

		getAPI() {
			if (!this.queryServiceAPI) {
				this.queryServiceAPI = APIFactory.createAPI(this, [QueryServiceAPI2]);
			}
			return this.queryServiceAPI;
		}

		destroy() {
			// Query definition uses APIFactory, but is not a traditional feature.
			// This means the necessary APIFactory destroy is not automatically called.
			// This ensures we do not leak once the dashboard is closed, but ideally we
			// would have cleaned up as we go. This implicates more involved changes though
			// which cannot be justified at this time.. this is still much better than leaving
			// it unaddressed :)
			this.queryDefinitions.forEach((queryDefinition, index) => {
				queryDefinition.destroy();
				delete this.queryDefinitions[index];
			});
			this.queryDefinitions = null;
		}

		registerQueryClass(queryProtocol, QueryClass) {
			if(this.queryClasses[queryProtocol]) {
				throw new Error(`There is already a query class registered for ${queryProtocol}`);
			}
			this.queryClasses[queryProtocol] = QueryClass;
		}

		createQueryDefinition(id, type) {
			const queryDefinition = new QueryDefinition({ id, type });
			this.queryDefinitions.push(queryDefinition);
			return queryDefinition.getAPI();
		}

		_getProtocol(definitionList) {
			const datasource = definitionList && definitionList.length > 0 ? definitionList[0].getDataSource() : null;
			return datasource && datasource.getProtocol();
		}

		createQuery(definitionList) {
			const queryProtocol = this._getProtocol(definitionList);
			const QueryClass = this.queryClasses[queryProtocol];
			if (QueryClass) {
				return new QueryClass({
					dashboard: this.dashboard,
					internalQueryService: this.internalQueryService,
					definitionList
				});
			} else  {
				throw new Error(`Query class is not registered for ${queryProtocol}`);
			}
		}
	}

	return QueryService2;
});
